"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FutureBillsState_1 = require("./FutureBillsState");
var localStyles = require("./FutureBills.scss");
var ReportingService_1 = require("../../api/ReportingService");
var Api_1 = require("../../api/Api");
var ui_components_1 = require("@idp/ui-components");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var ButtonProps_1 = require("@idp/ui-components/components/atoms/Button/ButtonProps");
var routables_1 = require("@idp/routables");
var Accordion_1 = require("../atoms/Accordion");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../cms/Cart.cms");
var icons = require("../../styles/ccc-icons-cart.scss");
var utils_1 = require("@idp/ui-components/utils");
var Util = require("../../utils/UtilityFunctions");
var CartConfiguration_scss_1 = require("../CartConfigurationContainer/CartConfiguration.scss");
var CartUtilFunctions_1 = require("../../utils/CartUtilFunctions");
var BroadbandCart_cms_1 = require("../CartLob/BroadbandCart/BroadbandCart.cms");
var components_1 = require("@idp/duc/components");
var FutureBills = /** @class */ (function (_super) {
    __extends(FutureBills, _super);
    function FutureBills(props) {
        var _this = _super.call(this, props) || this;
        _this.bbCmsContent = new BroadbandCart_cms_1.BroadbandCartCms();
        _this.futureBillFilterData = new Array();
        _this.isSpecialBBPricing = CartUtilFunctions_1.isSpecialBBPricing(_this.bbCmsContent.specialHsiaOffers);
        _this.api = new Api_1.default();
        _this.state = new FutureBillsState_1.default();
        _this.onFutureBillsModlaClose = _this.onFutureBillsModlaClose.bind(_this);
        _this.reportingService = new ReportingService_1.default();
        return _this;
    }
    FutureBills.prototype.componentWillMount = function () {
        var payload = this.props.data;
        var currentLobType = null;
        var isHsiaInstantOn = false;
        if (payload && payload.broadbandCart) {
            currentLobType = 'BROADBAND';
            isHsiaInstantOn = payload.broadbandCart.hsiaInstantOnCustomer;
        }
        this.setState({ currentLobType: currentLobType, isBundle: Util.isBundleinCart().isBundleWithoutAccessory, isHsiaInstantOn: isHsiaInstantOn });
    };
    FutureBills.prototype.render = function () {
        this.futureBillsCmsTexts = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common.futureBills;
        if (this.state.currentLobType === 'DTVS' || this.state.currentLobType === 'BROADBAND' ||
            this.state.currentLobType === 'IPTV') {
            var linkLabel = this.futureBillsCmsTexts.seeEstimatedLinkLabel;
            return (React.createElement("div", { className: localStyles.futureBillPanel },
                React.createElement("div", { className: localStyles.futureBillLink },
                    React.createElement("i", { tabIndex: 0, role: "img", "aria-label": "Icon", className: [icons.cccIconCart, icons.cccIconCartTimeandmoney,
                            localStyles.icontimenmoney].join(' ') }),
                    React.createElement(components_1.Link, { kind: "textPlain", onClick: this.seeFutureBills.bind(this, linkLabel), testId: components_1.Link.name + '_' + linkLabel }, linkLabel)),
                this.showFutureBillModal()));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    FutureBills.prototype.seeFutureBills = function (linkName) {
        var _this = this;
        this.props.events.doLoading(true);
        this.setState({ isLoading: true });
        this.reportingService.fireLinkClickWithOutPageLoad(linkName, ReportingService_1.PageUrls.SEE_YOUR_FUTURE_BILL_URL);
        this.reportingService.reportSystemEventForSelectedAction(false, '-2', linkName, ReportingService_1.EventTypesCodes.FUTURE_BILL_SUBMIT_EVENT, ReportingService_1.PageUrls.SEE_YOUR_FUTURE_BILL_URL, ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, undefined);
        this.api.getFutureBills().then(function (response) {
            if (response && response.content) {
                _this.reportingService.reportSystemEventForSelectedAction(false, '0', linkName, ReportingService_1.EventTypesCodes.FUTURE_BILL_SUBMIT_EVENT, ReportingService_1.PageUrls.SEE_YOUR_FUTURE_BILL_URL, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, undefined);
                _this.filterFutureBillInfo(response);
            }
            else if (response && response.error) {
                _this.setState({ isRepError: true });
                _this.reportingService.reportSystemEventForSelectedAction(true, response.error && response.error.errorId, linkName, ReportingService_1.EventTypesCodes.FUTURE_BILL_SUBMIT_EVENT, ReportingService_1.PageUrls.SEE_YOUR_FUTURE_BILL_URL, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, response.error && response.error.message);
            }
            _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.SEE_YOUR_FUTURE_BILL_URL);
            _this.props.events.doLoading(false);
            _this.setState({ isLoading: false });
        })
            .catch(function (err) {
            _this.props.events.doLoading(false);
            _this.setState({ showFutureBillsModal: true, isRepError: true, isLoading: false });
            _this.reportingService.reportSystemEventForSelectedAction(true, undefined, linkName, ReportingService_1.EventTypesCodes.FUTURE_BILL_SUBMIT_EVENT, ReportingService_1.PageUrls.SEE_YOUR_FUTURE_BILL_URL, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, 'Error future bill selection: ' + JSON.stringify(err));
        });
    };
    FutureBills.prototype.onFutureBillsModalCheckout = function () {
        this.setState({ showFutureBillsModal: false });
        routables_1.history.push('/checkout/checkoutview');
    };
    FutureBills.prototype.onFutureBillsModlaClose = function () {
        this.setState({ showFutureBillsModal: false });
        this.reportingService.fireLinkClickWithOutPageLoad('Close', ReportingService_1.PageUrls.SEE_YOUR_FUTURE_BILL_URL);
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
    };
    FutureBills.prototype.showFutureBillModal = function () {
        var _this = this;
        var isPSCBBDTVSIntent = CartUtilFunctions_1.getPscBBFlag();
        var noteFutureText = this.isSpecialBBPricing ?
            this.futureBillsCmsTexts.bbPricingNoteSection1Txt :
            isPSCBBDTVSIntent ? '' :
                this.futureBillsCmsTexts.noteSection1Txt;
        return (React.createElement(ui_components_1.Modal, { testId: "Modal_Future_Bills_Details", options: { className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                isRedesign: true,
                show: this.state.showFutureBillsModal && !this.state.isLoading,
                showClose: true, size: ModalProps_1.ModalSizes.LARGE }, events: { onClose: this.onFutureBillsModlaClose }, accessibilityText: "_Future_Bills_Details" },
            React.createElement("div", { className: CartConfiguration_scss_1.rennyModalContainer },
                this.state.isRepError && this.errorMsg(),
                !this.state.isRepError &&
                    React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement(Accordion_1.default, { data: {
                                    isSingleChild: true,
                                    sectionDescription: React.createElement("div", null, this.isSpecialBBPricing ?
                                        this.futureBillsCmsTexts.bbPricingModalDiscLabel : isPSCBBDTVSIntent ?
                                        this.futureBillsCmsTexts.pscbbdtvsModalDiscLabel :
                                        this.futureBillsCmsTexts.modalDiscLabel),
                                    sectionTitle: React.createElement("div", null, this.futureBillsCmsTexts.modalTitleLabel),
                                } })),
                        this.futureBillFilterData.map(function (billObject, index) {
                            return (React.createElement("div", { key: '_Accord' + index },
                                React.createElement(Accordion_1.default, { data: {
                                        isSingleChild: false,
                                        sectionDescription: _this.getSectionDescription(billObject, index, isPSCBBDTVSIntent),
                                        sectionTitle: _this.getSectionTitle(billObject),
                                    } })));
                        }),
                        React.createElement("div", { className: [localStyles.noteText, localStyles.modalbotpadding].join(' ') },
                            React.createElement("div", { className: localStyles.padding10b },
                                React.createElement(ui_components_1.Label, { data: {
                                        text: noteFutureText,
                                    }, options: { className: localStyles.labelstyle } })),
                            React.createElement("div", { className: localStyles.padding10b },
                                React.createElement(ui_components_1.Label, { data: {
                                        text: this.isSpecialBBPricing ?
                                            this.futureBillsCmsTexts.bbPricingNoteSection2Txt :
                                            isPSCBBDTVSIntent ? this.futureBillsCmsTexts.pscbbdtvsNoteSection2Txt :
                                                this.futureBillsCmsTexts.noteSection2Txt,
                                    }, options: { className: localStyles.labelstyle } })),
                            React.createElement("div", { className: localStyles.padding10b },
                                React.createElement(ui_components_1.Label, { data: {
                                        text: this.isSpecialBBPricing ?
                                            this.futureBillsCmsTexts.bbPricingNoteSection3Txt :
                                            this.futureBillsCmsTexts.noteSection3Txt,
                                    }, options: { className: localStyles.labelstyle } })),
                            this.state.isHsiaInstantOn &&
                                React.createElement("div", null,
                                    React.createElement("div", { className: localStyles.padding10b },
                                        React.createElement(ui_components_1.Label, { data: { text: this.futureBillsCmsTexts.noteSection4Txt }, options: { className: localStyles.labelstyle } })),
                                    React.createElement("div", { className: localStyles.padding10b },
                                        React.createElement(ui_components_1.Label, { data: { text: this.futureBillsCmsTexts.noteSection5Txt }, options: { className: localStyles.labelstyle } })),
                                    React.createElement("div", { className: localStyles.padding10b },
                                        React.createElement(ui_components_1.Label, { data: { text: this.futureBillsCmsTexts.noteSection6Txt }, options: { className: localStyles.labelstyle } })))),
                        React.createElement("div", { className: localStyles.hrline, "aria-hidden": "true" })),
                React.createElement("div", { className: [localStyles.buttonAlign, localStyles.modalbotpadding].join(' ') },
                    React.createElement(ui_components_1.Button, { data: { text: this.futureBillsCmsTexts.checkoutCtaLabel, disabled: false }, events: {
                            onClick: function () {
                                _this.onFutureBillsModalCheckout();
                            },
                        }, options: { size: ButtonProps_1.ButtonSize.MEDIUM, className: localStyles.continueBtn }, testId: utils_1.default('Button', '_futureBill') })),
                React.createElement("div", { className: [localStyles.buttonAlign, localStyles.modalbotpadding].join(' ') },
                    React.createElement(ui_components_1.Button, { data: { text: this.futureBillsCmsTexts.closeCtaLabel, disabled: false }, events: {
                            onClick: function () {
                                _this.onFutureBillsModlaClose();
                            },
                        }, options: { size: ButtonProps_1.ButtonSize.MEDIUM, className: localStyles.closeBtn }, testId: utils_1.default('Button', '_futureBill') })))));
    };
    FutureBills.prototype.filterFutureBillInfo = function (response) {
        this.futureBillFilterData = [];
        var isRepError = false;
        if (response.content && response.content.payload && response.content.payload.futureBills) {
            var futureBills = JSON.parse(JSON.parse(JSON.stringify(response.content.payload.futureBills)));
            if (futureBills.length > 0) {
                for (var fIndex in futureBills) {
                    if (futureBills[fIndex].description && futureBills[fIndex].description !== '1000') {
                        this.futureBillFilterData.push(futureBills[fIndex]);
                    }
                }
            }
            else {
                isRepError = true;
            }
        }
        else {
            isRepError = true;
        }
        this.setState({ showFutureBillsModal: true, isRepError: isRepError });
    };
    FutureBills.prototype.getSectionTitle = function (obj) {
        return (React.createElement("div", { className: localStyles.accordianlist },
            React.createElement("div", { className: localStyles.floatl }, this.getTitle(obj)),
            React.createElement("div", { className: localStyles.floatr }, this.priceFormat(obj.subTotal)),
            React.createElement("div", { className: localStyles.clearboth })));
    };
    FutureBills.prototype.getSectionDescription = function (obj, index, isPSCBBDTVSIntent) {
        var _this = this;
        var payload = this.props.data;
        var startingText = isPSCBBDTVSIntent ? this.futureBillsCmsTexts.pscBBPriceTxt
            : this.state.isBundle ? this.futureBillsCmsTexts.bundleLobsStartingTxt
                : this.state.currentLobType === 'BROADBAND' ? this.futureBillsCmsTexts.bundlePriceStartingTxtBroadBand
                    : this.futureBillsCmsTexts.bundlePriceStartingTxt;
        var RegularTxt = isPSCBBDTVSIntent ? this.futureBillsCmsTexts.pscBBPriceTxt
            : this.state.isBundle ? this.futureBillsCmsTexts.bundleLobsRegularTxt
                : this.futureBillsCmsTexts.bundlePriceRegularTxt;
        var promoName = '';
        if ((obj.discounts.length > 0) && obj.discounts) {
            obj.discounts.map(function (value, dicIndex) {
                if (dicIndex === 0) {
                    promoName = value.description;
                }
                else {
                    promoName = promoName + ' + ' + value.description;
                }
            });
        }
        return (React.createElement("div", null,
            ((Number(obj.bundlePrice) !== 0) && obj.bundlePrice) &&
                (this.futureBillFilterData.length !== (index + 1)) &&
                this.getDescription(startingText, obj.bundlePrice),
            ((Number(obj.bundlePrice) !== 0) && obj.bundlePrice) &&
                (this.futureBillFilterData.length === (index + 1)) &&
                this.getDescription(RegularTxt, obj.bundlePrice),
            ((Number(obj.additionalCharges) !== 0) && obj.additionalCharges) &&
                this.getDescription(this.futureBillsCmsTexts.additionalChargesTxt, obj.additionalCharges),
            ((Number(obj.annualCost) !== 0) && obj.annualCost) &&
                this.getDescription(this.futureBillsCmsTexts.seasonalSubsTxt, obj.annualCost, this.futureBillsCmsTexts.installmentChannelChargeOnetimeTxt),
            ((Number(obj.installmentChannelCharge) !== 0) && obj.installmentChannelCharge) &&
                this.getDescription(this.futureBillsCmsTexts.seasonalSubsTxt, obj.installmentChannelCharge, this.futureBillsCmsTexts.installmentChannelChargeInstallmentTxt),
            ((Number(obj.oneTimeCost) !== 0) && obj.oneTimeCost) &&
                this.getDescription(this.futureBillsCmsTexts.oneTimeCostTxt, obj.oneTimeCost),
            (this.state.currentLobType === 'DTVS' || this.state.currentLobType === 'IPTV') &&
                ((Number(obj.installmentCharge) !== 0) && obj.installmentCharge) &&
                this.getDescription(this.futureBillsCmsTexts.tvInstallmentBillingChargeTxt, obj.installmentCharge),
            (this.state.currentLobType === 'BROADBAND') &&
                ((Number(obj.installmentCharge) !== 0) && obj.installmentCharge) &&
                this.getDescription(this.futureBillsCmsTexts.internetInstallmentBillingChargeTxt, obj.installmentCharge),
            ((obj.discounts.length > 0) && obj.discounts) &&
                React.createElement("div", null,
                    React.createElement("div", { className: localStyles.discountsec },
                        React.createElement("div", { className: [localStyles.description, localStyles.padding10b].join(' ') },
                            React.createElement(ui_components_1.Label, { testId: 'billdiscount', data: { text: this.futureBillsCmsTexts.discountsLabel } }),
                            React.createElement("br", null),
                            React.createElement("span", { className: localStyles.greytxt }, this.futureBillsCmsTexts.monthlyDiscountDisLabel)),
                        React.createElement("div", { className: localStyles.price }, "\u00A0"),
                        React.createElement("div", { className: localStyles.clearboth })),
                    (payload === null || payload === void 0 ? void 0 : payload.broadbandCart) &&
                        React.createElement("div", { key: '_disc' + index, className: localStyles.discountColor },
                            React.createElement("div", { className: [localStyles.description, localStyles.descgreen].join(' ') },
                                " ",
                                promoName,
                                " "),
                            React.createElement("div", { className: localStyles.clearboth })),
                    !(payload === null || payload === void 0 ? void 0 : payload.broadbandCart) &&
                        obj.discounts.map(function (value, dicIndex) {
                            return (React.createElement("div", { key: '_disc' + dicIndex, className: localStyles.discountColor },
                                React.createElement("div", { className: [localStyles.description, localStyles.descgreen].join(' '), tabIndex: 0 }, value.description),
                                React.createElement("div", { className: localStyles.price, tabIndex: 0 }, _this.priceFormat(value.price)),
                                React.createElement("div", { className: localStyles.clearboth })));
                        }))));
    };
    FutureBills.prototype.getTitle = function (obj) {
        var title;
        var dynTxtArry = String(obj.description).split('-');
        if (Number(obj.description) === 1 && dynTxtArry.length === 1) {
            title = this.futureBillsCmsTexts.modalFirstBillLabel;
        }
        else if (dynTxtArry.length > 1 && dynTxtArry[1].length < 3) {
            title = this.cmsDynamicContent(this.futureBillsCmsTexts.modalMonthsLabel, dynTxtArry);
        }
        else if (dynTxtArry.length > 1 && dynTxtArry[1].length > 3) {
            title = this.cmsDynamicContent(this.futureBillsCmsTexts.andLaterLabel, dynTxtArry);
        }
        else {
            title = this.cmsDynamicContent(this.futureBillsCmsTexts.andLaterLabel, dynTxtArry);
        }
        return title;
    };
    FutureBills.prototype.getDescription = function (disc1, price, disc2) {
        return (React.createElement("div", null,
            React.createElement("div", { className: [localStyles.description, localStyles.descblack].join(' '), tabIndex: 0 },
                React.createElement("span", null, disc1),
                disc2 &&
                    React.createElement("span", { className: localStyles.greytxt },
                        " ",
                        disc2,
                        " ")),
            React.createElement("div", { className: localStyles.price, tabIndex: 0 }, this.priceFormat(price)),
            React.createElement("div", { className: localStyles.clearboth })));
    };
    FutureBills.prototype.priceFormat = function (val) {
        var price = Number(val).toFixed(2);
        var priceToDisplay = '$' + price;
        if (price.indexOf('-') !== -1) {
            priceToDisplay = price.replace('-', '-$');
        }
        return priceToDisplay;
    };
    FutureBills.prototype.errorMsg = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: localStyles.futureTitle }, this.futureBillsCmsTexts.modalTitleLabel),
            React.createElement(components_1.Alert, { closeable: false, onWhite: true, testId: utils_1.default('Cart', 'FutureBillError', '_msg'), type: "error" },
                React.createElement(ui_components_1.Label, { data: { text: this.futureBillsCmsTexts.apiErrTxt }, options: {
                        className: localStyles.errormsg,
                        size: LabelProps_1.LabelSizes.MEDIUM,
                    } }))));
    };
    FutureBills.prototype.cmsDynamicContent = function (content, txtArry) {
        var text = content;
        for (var index in txtArry) {
            if (txtArry[index]) {
                var conttoreplace = String('{' + index + '}');
                text = text.replace(conttoreplace, String(txtArry[index]));
            }
        }
        return text;
    };
    return FutureBills;
}(React.Component));
exports.default = FutureBills;
//# sourceMappingURL=FutureBills.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/FutureBills/FutureBills.js
// module id = 2331
// module chunks = 8